import request from './request.js';
import {requestbody} from './request.js'

//导入
export async function xxzzs_upload (params = {
}) {
return await request('oinv/file/upload', 'post', params)
}

//结果展示分页查询
export async function xxzzs_query (params = {
}) {
return await requestbody('oinv/list/query', 'post', params)
}
//明细列表分页
export async function xxzzs_mxquery (params = {
}) {
return await requestbody('oinv/detail/query', 'post', params)
}
//删除
export async function xxzzs_delete (params = {
}) {
return await requestbody('oinv/result/delete', 'post', params)
}
//查询业务类型
export async function xxzzs_ywlxquery(params = {}) {
    return await requestbody('business/queryType', 'post', params);
}
// 保存发票同步任务
export async function syncInvoiceInfo(params = {

}) {
    return await requestbody('/batch/syncInvoiceInfo', 'post', params)
}